import styled from '@emotion/styled';

const StyledRow = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  & > * {
    width: 28rem;
  }
`;

const GenderWrapper = styled('div')`
  max-width: 50%;
`;

export {StyledRow, GenderWrapper};
